// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"ca144260","360":"90031863","519":"67297624","637":"ffbbc56b","879":"93c51d47"}[chunkId] + ".chunk.css";
};